import { render, staticRenderFns } from "./MyTeams.vue?vue&type=template&id=5c51492f&scoped=true&"
import script from "./MyTeams.vue?vue&type=script&lang=js&"
export * from "./MyTeams.vue?vue&type=script&lang=js&"
import style0 from "./MyTeams.vue?vue&type=style&index=0&id=5c51492f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51492f",
  null
  
)

export default component.exports